import { render, staticRenderFns } from "./WhatDoesAccessibilityMean.vue?vue&type=template&id=469b4b7c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports